<template>
    <p>
        <template v-if="head">
            <span v-html="prefix.head" /><strong v-html="head" /><br>
        </template>
        <template v-if="trunk">
            <span v-html="prefix.trunk" /><strong v-html="trunk" /><br>
        </template>
        <template v-if="limbs">
            <span v-html="prefix.member" /><strong v-html="limbs" />
        </template>
    </p>
</template>
<script>
export default {
    name: "DasBundleAccessories",
    props: {
        prefix: {
            type: Object,
            required: true
        },
        head: {
            type: String,
            required: false,
            default: undefined
        },
        trunk: {
            type: String,
            required: false,
            default: undefined
        },
        limbs: {
            type: String,
            required: false,
            default: undefined
        },
    },
}
</script>

